export default {
  switchToMeaning: 'Switch to meaning',
};
